import React, { useContext, useEffect } from "react";
import {
  Table,
  Empty,
  Button,
  Input,
  Select,
  Popover,
} from "antd";
import { Dropdown } from "semantic-ui-react";
import { SearchOutlined } from "@ant-design/icons";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { TemplateContext } from "../../../utils/template_context";
import { useAsignarHojasdeVida } from "../../../hooks/useAsignarHojasdeVida";
import { openNotification } from "../../../utils/Notifactions";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
import { ModalAsignarJurado } from "./components/ModalAsignarJurado";
import { itemRenderTable, obtenerSelectCheckboxColumn } from "../../../utils/tablaConvocatoriaHelper";

export const AsignarHojasdeVida = () => {
  const {
    datosFiltro,
    setDatosFiltro,
    totalregistros,
    cantidadpáginas,
    cambiarCantidadPaginas,
    loading,
    areas,
    categorias,
    setCategorias,
    filtros,
    setFiltros,
    cargarJurados,
    obtenerAreas,
    handleAreaChange,
    buscarJurados,
    limpiarFiltros,
    cambiarCheckbox,
    toggleSeleccionarTodos,
    juradosSeleccionados,
    modalasignarjurados,
    setModalAsignarJurados,
  } = useAsignarHojasdeVida();

  const context = useContext(TemplateContext);

  useEffect(() => {
    cargarJurados();
    obtenerAreas();
  }, []);



  const columns: any = [
    {
      title: "No.",
      width: 50,
      render: (_: any, __: any, index: number) => <span>{index + 1}</span>,
      fixed: context.device === "lg" ? "left" : false,
    },
    {
      title: "Nro. Documento",
      width: 130,
      dataIndex: "numero_documento_participante",
      key: "numero_documento_participante",
    },
    {
      title: "Código",
      width: 130,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Expresión",
      width: 180,
      render: (datos: any) => <span>{datos.area ?? "Sin expresión"}</span>,
    },
    {
      title: "Categorías",
      width: 270,
      render: (datos: any) => {
        // categorias_area es array de objetos {id, nombre, checked}
        const raw: any[] = Array.isArray(datos.categorias_area) ? datos.categorias_area : [];
        // Excluir el último (modalidad); mostrar todos los del medio
        const categorias = raw.length > 1 ? raw.slice(0, -1) : raw;
        if (categorias.length === 0) return <span>Sin categorías</span>;

        const nombres = categorias.map((c: any) => c.nombre ?? String(c));
        const preview = nombres[0].length > 30 ? `${nombres[0].substring(0, 28)}...` : nombres[0];

        const content = (
          <ul style={{ paddingLeft: 16, margin: 0, maxWidth: 300 }}>
            {nombres.map((nombre: string, i: number) => (
              <li key={nombre} style={{ fontSize: 11 }}>{nombre}</li>
            ))}
          </ul>
        );

        return (
          <Popover content={content} title="Categorías">
            <span style={{ cursor: "pointer" }}>
              {preview}
              {nombres.length > 1 ? ` (+${nombres.length - 1})` : ""}
            </span>
          </Popover>
        );
      },
    },
    {
      title: "Modalidad",
      width: 180,
      render: (datos: any) => {
        const raw: any[] = Array.isArray(datos.categorias_area) ? datos.categorias_area : [];
        if (raw.length === 0) return <span>Sin modalidad</span>;
        // La modalidad es el último elemento
        const ultimo = raw[raw.length - 1];
        return <span>{ultimo?.nombre ?? String(ultimo)}</span>;
      },
    },
    {
      title: "Estado",
      width: 110,
      render: (datos: any) => {
        const status = datos.status ?? datos.estado ?? "";
        return (
          <span style={{ color: "#00904C", fontWeight: 500 }}>
            {status === "Aceptó" ? "En estudio" : status}
          </span>
        );
      },
    },
    obtenerSelectCheckboxColumn(datosFiltro, toggleSeleccionarTodos, cambiarCheckbox, 130, context.device),
  ];

  const routes = [
    { nombre: "Gestión jurados" },
    { nombre: "Asignar hoja de vida" },
  ];

  return (
    <div className="background-color-F7FBFF height-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Asignar hoja de vida a jurados
        </div>

        {/* Filtros */}
        <div className="sombra_card" style={{ marginBottom: "20px" }}>
          <div>
            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Filtrar jurados
              </div>
            </div>
            <div className="body_card">
              <div className="row">

                {/* Palabra clave */}
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div>
                    <div className="col-12">
                      <span className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">
                        Filtrar documento o código
                      </span>
                    </div>
                    <div className="col-12">
                      <Input
                        suffix={<SearchOutlined className="font-color-051923bf" />}
                        value={filtros.buscarpalabra}
                        placeholder="Buscar..."
                        onChange={(e) =>
                          setFiltros({ ...filtros, buscarpalabra: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Área */}
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div>
                    <div className="col-12">
                      <span className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">
                        Filtrar por expresión
                      </span>
                    </div>
                    <div className="col-12">
                      <Select
                        showSearch
                        allowClear
                        value={filtros.area}
                        optionFilterProp="children"
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        onChange={(value: any) => handleAreaChange(value)}
                        onClear={() => {
                          setFiltros({ ...filtros, area: null, categoria: null });
                          setCategorias([]);
                        }}
                      >
                        {areas.map((a: any) => (
                          <Select.Option key={a.id_area} value={a.id_area}>
                            {a.nombre_area}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>

                {/* Categoría */}
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div>
                    <div className="col-12">
                      <span className="font-color-4B4B4B font-family-Montserrat-SemiBold font-size-12px pb-2">
                        Filtrar por categoría
                      </span>
                    </div>
                    <div className="col-12">
                      <Select
                        showSearch
                        allowClear
                        value={filtros.categoria}
                        optionFilterProp="children"
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        disabled={categorias.length === 0}
                        onChange={(value: any) =>
                          setFiltros({ ...filtros, categoria: value })
                        }
                      >
                        {categorias.map((c: any) => {
                          const cId = c.id ?? c.id_categoria;
                          const cNombre = c.nombre ?? c.nombre_categoria ?? "";
                          return (
                            <Select.Option key={cId} value={cId}>
                              {cNombre}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button className="button-azul-ghost m-0" onClick={limpiarFiltros}>
                Limpiar
              </Button>
              <Button className="button-blanco-radius m-0" onClick={buscarJurados}>
                Buscar
              </Button>
            </div>
          </div>
        </div>

        {/* Tabla */}
        <div
          className="row-shadow"
          style={{ marginBottom: "6%", marginTop: "16px" }}
        >
          <div className="col-12">
            <div className="row">
              <div
                className="col-12 col-md-6 justify-content-flex-start order-0 font-size-14px font-family-Montserrat-Regular"
                style={{ paddingBottom: "0%" }}
              >
                Lista de jurados (En estudio / Por evaluar)
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                <div className="d-flex justify-content-end pe-3">
                  Seleccionados:{" "}
                  <span className="font-color-F28C02 ps-1">
                    {juradosSeleccionados.length}
                  </span>
                </div>
                <div className="d-flex justify-content-end pe-3">
                  Total:{" "}
                  <span className="font-color-F28C02 ps-1">{totalregistros}</span>
                </div>
                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <span className="font-family-Montserrat-Regular font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </span>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadpáginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg />}
                    onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se encontraron jurados en estudio"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadpáginas,
                  }}
                  dataSource={datosFiltro}
                  columns={columns}
                  size="small"
                  bordered={false}
                  loading={loading}
                  rowKey={(record: any, index: any) =>
                    record.id_jurado ?? record.radicado ?? record.numero_documento_participante ?? index
                  }
                  scroll={{ x: 1300, y: 400 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer con botón de asignar */}
      <div className="container-sticky-footer justify-content-flex-end">
        <div className="justify-content-flex-end" style={{ paddingRight: "16px" }}>
        </div>
        <div>
          <Button
            className="button-azul-radius width-100"
            onClick={() => {
              if (juradosSeleccionados.length === 0) {
                return openNotification({
                  titulo: "Error",
                  descripcion: "Debe seleccionar al menos un jurado",
                  placement: "bottomRight",
                });
              }
              console.log("juradosSeleccionados", juradosSeleccionados);
              return setModalAsignarJurados(true);
            }}
          >
            Asignar jurados
          </Button>
        </div>
      </div>

      {modalasignarjurados && (
        <ModalAsignarJurado
          postulaciones={juradosSeleccionados}
          setPostulaciones={setDatosFiltro}
          modal={modalasignarjurados}
          AceptarModal={() => setModalAsignarJurados(false)}
          CancelarModal={() => setModalAsignarJurados(false)}
        />
      )}
    </div>
  );
};
